import * as React from "react"
import { useState } from "react"
import { navigate } from "gatsby"
import PropTypes from "prop-types"
import ShopHeader from "./ShopHeader"
import { useLocation } from "@reach/router"
import Breadcrumbs from "./Breadcrumbs"
import ShopMenu from "./ShopMenu"
import HomeMenu from "./HomeMenu"
import NewsTicker from "./NewsTicker"

const Header = ({ breadcrumbs, shop, title, canonical, mobileMenu, setMobileMenu }) => {
  const [keyword, setKeyword] = useState("")

  const onSearch = e => {
    e.preventDefault()
    navigate("/search?q=" + keyword, { state: { keyword } })
  }
  return (
    <header itemScope itemType="https://schema.org/WPHeader" className="md:pt-0 pt-12">
      <NewsTicker />
      {shop ? (
        <ShopHeader
          keyword={keyword}
          setKeyword={setKeyword}
          onSearch={onSearch}
          dropdown={mobileMenu}
          setDropdown={setMobileMenu}
        />
      ) : (
        ""
      )}
      {shop ? (
        <ShopMenu dropdown={mobileMenu} setDropdown={setMobileMenu} />
      ) : (
        <HomeMenu dropdown={mobileMenu} setDropdown={setMobileMenu} />
      )}
      {breadcrumbs ? (
        <Breadcrumbs
          breadcrumbs={breadcrumbs}
          canonical={canonical}
          title={title}
          location={useLocation().href}
          origin={useLocation().origin}
        />
      ) : (
        ""
      )}
    </header>
  )
}

Header.propTypes = {
  breadcrumbs: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        name: PropTypes.string,
      })
    ),
  ]),
  shop: PropTypes.bool,
  canonical: PropTypes.string,
  title: PropTypes.string,
}

Header.defaultProps = {
  breadcrumbs: false,
  shop: false,
  canonical: null,
  title: null,
}

export default Header
